<div class="title">
    <mat-card-title>{{ isReconfiguration ? 'Edit Job' : 'Add new Job' }}</mat-card-title>
</div>

<form [formGroup]="addJobForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
        <mat-select placeholder="Job type" [required]="true" [(value)]="selectedJobType"
            (selectionChange)="onChange($event.value)" [disabled]="isReconfiguration">
            <mat-option *ngFor="let jobType of jobsList" [value]="jobType"
                matTooltip="{{getTaskDescriptionByTaskType(jobType)}}"> {{getPrettyTaskType(jobType)}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <br>

    <mat-form-field>
        <input required matInput placeholder="Name" formControlName="name">
    </mat-form-field>

    <div *ngIf="showZoningCodeSubform">
        <app-zoning-code-subform (formReady)="formInitialized('zoningCodeForm', $event)"
            [zoningCodeStatuses]="getAllwedZCStatuses()"
            [isZoningCodeOptional]="isZoningCodeOptional"></app-zoning-code-subform>
    </div>

    <div *ngIf="showTypologySubform">
        <app-typology-subform (formReady)="formInitialized('typologyForm', $event)"> </app-typology-subform>
    </div>

    <div *ngIf="showZoningCodeVersionSubform">
        <app-zc-version-select-subform (formReady)="formInitialized('zcvForm', $event)">
        </app-zc-version-select-subform>
    </div>

    <div *ngIf="showListsSubform">
        <app-calculate-folio-subform [jobType]="selectedJobType" [place]="process ? process.place : null"
            [showZoningCodeSettings]="showZoningCodeSettings" [forcedModeEnabled]="!forcedModeDisabled"
            (formReady)="formInitialized('listForm', $event)"
            (needToRecalculateChange)="onNeedToRecalculateChange($event)">
        </app-calculate-folio-subform>
    </div>

    <!-- <div *ngIf="showImportNewIdsSubform">
        <import-new-ids-subform-subform (formReady)="formInitialized('idsSourceUrlForm', $event)">
        </import-new-ids-subform-subform>
    </div> -->

    <div *ngIf="showRecalculateForm">
        <app-recalculate-by-status (formReady)="formInitialized('recalculateForm', $event)">
        </app-recalculate-by-status>
    </div>

    <div *ngIf="showFileChooserSubform">
        <app-file-chooser-subform
            (formReady)="formInitialized('fileChooserSubform', $event)"></app-file-chooser-subform>
    </div>

    <div *ngIf="showDataSourceCategorySubform">
        <app-data-source-category-subform
            (formReady)="formInitialized('dataSourceCategories', $event)"></app-data-source-category-subform>
    </div>

    <div *ngIf="showSyncSolrUADataCheckbox">
        <mat-checkbox formControlName="syncSolrData">Sync Solr AU Data</mat-checkbox>
    </div>

    <div *ngIf="showSaveRawIds">
        <mat-checkbox formControlName="saveRawIds">Save raw Property Record Ids for debug</mat-checkbox>
    </div>

    <div *ngIf="showRecalculateAllPRsCheckbox">
        <mat-checkbox
            title="If checked, then Job will forse recalculation for all PRs in the provided list, instead of check if recalculation is needed basic on changes in the lists of places."
            formControlName="recalculateAllPRs">Recalculate all listed Property Records</mat-checkbox>
    </div>

    <div class="checkbox">
        <mat-checkbox formControlName="startImmediately">Start immediately</mat-checkbox>
    </div>

    <br>

    <button mat-raised-button color="primary" [disabled]="!canSave">{{ isReconfiguration ? 'Save' : 'Create'
        }}</button>
    <button mat-button color="warn" [mat-dialog-close]="false" (click)="onNoClick()">Cancel</button>
</form>

<!--{{ addJobForm.value | json }}-->